

export default {
    async setBudgetMinMax(){
        try {
            const response = await $fetch(useCountryPath('/diamond/filter/min-max'));   
            
            if(response?.data?.price){
                this.commitMutation('setBudgetPrice', response.data.price)
                return response
            }

        } catch (error) {
           return error
        }

    },

    updateBudget(PriceTo) {
        this.commitMutation('updateBudgetPrice',PriceTo)
    },

    setShape (Shape) {
        this.commitMutation('setDiamondShape',Shape)
    },

    setPrioritySort(Sort,Color,Clarity) {
        this.commitMutation('setPrioritySize', {Sort, Color, Clarity })
    },

    setPriorityColorClarity(Color,Clarity,Sort) {
        
        this.commitMutation('setPriorityQuality', { Color, Clarity,Sort });
    },

    
    setPriorityColorClaritySort(Color, Clarity, Sort) {
        this.commitMutation('setPriorityBalance', { Color, Clarity, Sort });
    },

    setResult(result) {
        this.commitMutation('setUpdatedResult',result)
    },

    setCurrentPage(page) {
        this.currentPage = page;  // Update the current page
    },

    setNextPage() {
        if(this.currentPage < this.totalPages) {
            this.commitMutation('setNextPage')
        }
    },
    
    setPrevPage() {
        if(this.currentPage > 1) {
            this.commitMutation('setPrevPage')
        }
    }
    
   
}


